<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="tips-tooltip regular"
      :style="tooltipStyle"
      @click.stop="hideTooltip"
    >
      <slot>{{ content }}</slot>
    </div>
  </transition>
</template>

<script>
// import导入组件工具等
export default {
  data() {
    return {
      visible: false,
      content: '',
      position: {
        bottom: 0,
        left: 0,
      },
    }
  },
  // 组件方法
  methods: {
    showTooltip(event, content = '') {
      if (!event) return

      // 获取点击位置
      const clickX = event.clientX || event.pageX || 0
      const clickY = event.clientY || event.pageY || 0

      // 设置内容
      this.content = content

      // 计算位置（显示在点击位置的左下角，并向左上移动）
      // 先设置一个临时位置，等 DOM 更新后再计算精确位置
      const windowHeight = window.innerHeight
      this.position = {
        bottom: windowHeight - clickY,
        left: clickX,
      }

      // 显示 tooltip
      this.visible = true

      // 等待 DOM 更新后计算精确位置
      this.$nextTick(() => {
        this.calculatePosition(clickX, clickY)
      })
    },

    calculatePosition(clickX, clickY) {
      const tooltipEl = this.$el
      if (!tooltipEl) return

      // 获取 tooltip 的尺寸
      const tooltipRect = tooltipEl.getBoundingClientRect()
      const tooltipWidth = tooltipRect.width
      const tooltipHeight = tooltipRect.height

      // 获取窗口尺寸
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight

      // 左下角对齐点击位置，并向左上移动一些距离
      const offsetX = 0 // 向左移动的距离
      const offsetY = 10 // 向上移动的距离

      // tooltip 的左下角对齐到点击位置，然后向左上移动
      // 使用 bottom 定位：从窗口底部到 tooltip 底部的距离
      let left = clickX - offsetX // 向左移动
      let bottom = windowHeight - clickY + offsetY // 向上移动（左下角对齐，向上移动 offsetY）

      // 边界检测：如果超出右边界，则右边缘对齐到窗口右边缘
      if (left + tooltipWidth > windowWidth - 8) {
        left = windowWidth - tooltipWidth - 8
      }

      // 边界检测：如果超出左边界，则左边缘对齐到窗口左边缘
      if (left < 8) {
        left = 8
      }

      // 边界检测：如果超出上边界（bottom 太大），则显示在点击位置下方
      if (bottom + tooltipHeight > windowHeight - 8) {
        bottom = windowHeight - clickY - offsetY
      }

      // 边界检测：如果超出下边界（bottom 太小），则调整到最小距离
      if (bottom < tooltipHeight + 8) {
        bottom = tooltipHeight + 8
      }

      this.position = {
        bottom: bottom,
        left: left,
      }
    },

    hideTooltip() {
      this.visible = false
      this.content = ''
    },

    handleDocumentClick(event) {
      // 如果点击的不是 tooltip 本身，则隐藏
      if (this.visible && this.$el && !this.$el.contains(event.target)) {
        this.hideTooltip()
      }
    },
  },
  // 计算属性
  computed: {
    tooltipStyle() {
      return {
        bottom: `${this.position.bottom}px`,
        left: `${this.position.left}px`,
      }
    },
  },
  // 侦听器
  watch: {},
  // import的组件需要声明
  components: {},
  created() {
    // 监听全局事件显示 tooltip
    this.$root.Bus.$on('showTooltips', (event, content) => {
      if (this.visible) return (this.visible = false)
      this.showTooltip(event, content)
    })

    // 监听全局事件隐藏 tooltip
    this.$root.Bus.$on('hideTooltips', () => {
      this.hideTooltip()
    })

    // 点击其他地方时隐藏 tooltip
    document.addEventListener('click', this.handleDocumentClick)
  },
  beforeDestroy() {
    // 移除事件监听
    this.$root.Bus.$off('showTooltips')
    this.$root.Bus.$off('hideTooltips')
    document.removeEventListener('click', this.handleDocumentClick)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tips-tooltip {
  position: fixed;
  z-index: 999999;
  background: #ffffff;
  box-shadow:
    0px 12px 24px 0px #0000001a,
    0px 6px 46px 0px #0000000f;
  border-radius: 8px;
  padding: 12px;
  max-width: 270px;
  min-width: 120px;
  pointer-events: auto;
  word-wrap: break-word;
  color: #202226;
  font-size: 14px;
  line-height: 1.1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
